function handleAddProductTbh(setInputs, setProductTab) {
  setProductTab('PDP');
  setInputs((prevInputs) => {
    return {
      ...prevInputs,
      product_tbh: [
        ...prevInputs.product_tbh,
        {
          name: `product ${(prevInputs.product_tbh?.length ?? 0) + 1}`,
          product_shape: 'rectangular',
          diameter: null,
          footprint: null,
          weight: 0,
          length: 0,
          width: 0,
          height: 0,
          throughput: 1,
          pdp: null,
        },
      ],
    };
  });
}

export default handleAddProductTbh;
